import store from "../store/store";

const isLogged = () => !!store.getState().security.token;

export default isLogged;
